import { createApp } from 'vue';
import { createBootstrap } from 'bootstrap-vue-next';

import router from '@/plugins/router';
import store from '@/plugins/vuex';
import '@/plugins/prism-editor';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import './global.css';

import App from './App.vue';

const app = createApp(App);
app.use(router);
app.use(store.original);
app.use(createBootstrap());
app.mount('#app');
